// PeriodicReportListTable.jsx
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow
} from '@mui/material';
import { getLocaleDateTime, getUserFullName } from 'app/utils/appHelpers';
import { useSelector } from 'react-redux';

function PeriodicReportListTable({ fileList, handleDeleteItem }) {
  const fontSettings = useSelector((state) => state.meeting.fontSettings);
  const { baseFontSize } = fontSettings;

  return (
    <Table size="small" sx={{ lineHeight: 1 }}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>Kullanıcı</TableCell>
          <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>Yıl</TableCell>
          <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>Dönem</TableCell>
          <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>Tarih</TableCell>
          <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>Sil</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {fileList && fileList.length > 0 ? (
          fileList.map((item) => (
            <TableRow key={item.id}>
              <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>
                {getUserFullName(item.user)}
              </TableCell>
              <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>
                {item.year}
              </TableCell>
              <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>
                {item.period}
              </TableCell>
              <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>
                {getLocaleDateTime(item.pdate)}
              </TableCell>
              <TableCell sx={{ fontSize: baseFontSize, lineHeight: 1 }}>
                <Button
                  style={{ minWidth: '40px' }}
                  onClick={() => handleDeleteItem(item)}
                >
                  <DeleteIcon color="error" sx={{ fontSize: fontSettings.iconFontSize }} />
                </Button>
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={5} align="center" sx={{ fontSize: baseFontSize, lineHeight: 1 }}>
              Dosya bulunmamaktadır
            </TableCell>
          </TableRow>
        )}
      </TableBody>
      <TableFooter></TableFooter>
    </Table>
  );
}

export default PeriodicReportListTable;
